import React from "react";

function GooglePlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="38"
      className="google-place-btn"
      viewBox="0 0 128 38"
    >
      <defs>
        <linearGradient
          id="linearGradient-1b"
          x1="61.103%"
          x2="25.944%"
          y1="4.84%"
          y2="71.968%"
        >
          <stop offset="0%" stopColor="#00A0FF"></stop>
          <stop offset=".7%" stopColor="#00A1FF"></stop>
          <stop offset="26%" stopColor="#00BEFF"></stop>
          <stop offset="51.2%" stopColor="#00D2FF"></stop>
          <stop offset="76%" stopColor="#00DFFF"></stop>
          <stop offset="100%" stopColor="#00E3FF"></stop>
        </linearGradient>
        <linearGradient
          id="linearGradient-2"
          x1="107.724%"
          x2="-130.67%"
          y1="49.424%"
          y2="49.424%"
        >
          <stop offset="0%" stopColor="#FFE000"></stop>
          <stop offset="40.9%" stopColor="#FFBD00"></stop>
          <stop offset="77.5%" stopColor="orange"></stop>
          <stop offset="100%" stopColor="#FF9C00"></stop>
        </linearGradient>
        <linearGradient
          id="linearGradient-3"
          x1="86.389%"
          x2="-49.886%"
          y1="30.966%"
          y2="135.389%"
        >
          <stop offset="0%" stopColor="#FF3A44"></stop>
          <stop offset="100%" stopColor="#C31162"></stop>
        </linearGradient>
        <linearGradient
          id="linearGradient-4"
          x1="-18.581%"
          x2="42.275%"
          y1="-11.243%"
          y2="35.172%"
        >
          <stop offset="0%" stopColor="#32A071"></stop>
          <stop offset="6.9%" stopColor="#2DA771"></stop>
          <stop offset="47.6%" stopColor="#15CF74"></stop>
          <stop offset="80.1%" stopColor="#06E775"></stop>
          <stop offset="100%" stopColor="#00F076"></stop>
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fillRule="nonzero" transform="translate(.888 .74)">
          <path
            fill="#000"
            d="M122.185 37.494H4.714c-2.632 0-4.7-2.06-4.7-4.682V4.716c0-2.622 2.068-4.682 4.7-4.682h117.471c2.632 0 4.7 2.06 4.7 4.682v28.096c0 2.622-2.068 4.682-4.7 4.682z"
          ></path>
          <path
            fill="#A6A6A6"
            d="M122.185.783c2.162 0 3.947 1.78 3.947 3.933v28.096c0 2.154-1.785 3.933-3.947 3.933H4.714c-2.162 0-3.948-1.78-3.948-3.933V4.716C.766 2.562 2.552.783 4.714.783h117.471zm0-.75H4.714c-2.632 0-4.7 2.155-4.7 4.683v28.096c0 2.622 2.068 4.682 4.7 4.682h117.471c2.632 0 4.7-2.06 4.7-4.682V4.716c0-2.528-2.068-4.682-4.7-4.682z"
          ></path>
          <path
            fill="#FFF"
            stroke="#FFF"
            strokeWidth="0.1"
            d="M44.562 9.617c0 .74-.188 1.39-.659 1.852-.565.556-1.224.834-2.072.834-.848 0-1.507-.278-2.072-.834-.566-.555-.848-1.204-.848-2.037 0-.834.282-1.483.848-2.038.565-.556 1.224-.834 2.072-.834.377 0 .753.093 1.13.278.377.185.66.37.848.648l-.471.463c-.377-.463-.848-.648-1.507-.648-.565 0-1.13.185-1.507.648-.471.371-.66.927-.66 1.575 0 .649.189 1.204.66 1.575.47.37.942.648 1.507.648.66 0 1.13-.185 1.601-.648.283-.278.471-.648.471-1.112h-2.072v-.74h2.731v.37h0zM48.895 7.3h-2.543v1.76h2.355v.648h-2.355v1.76h2.543v.741H45.6V6.653h3.296V7.3zm3.109 4.91h-.754V7.3H49.65v-.648h3.956V7.3h-1.601v4.91zm4.332 0V6.652h.754v5.557h-.754zm3.957 0h-.754V7.3h-1.601v-.648H61.8V7.3h-1.602v4.91h.095zm8.948-.742c-.565.556-1.225.834-2.072.834-.848 0-1.507-.278-2.073-.834-.565-.555-.847-1.204-.847-2.037 0-.834.282-1.483.847-2.038.566-.556 1.225-.834 2.073-.834.847 0 1.507.278 2.072.834.565.555.848 1.204.848 2.038 0 .833-.283 1.482-.848 2.037zm-3.58-.463c.377.37.942.649 1.508.649.565 0 1.13-.186 1.507-.649.377-.37.66-.926.66-1.574 0-.649-.19-1.205-.66-1.575-.377-.37-.942-.649-1.507-.649-.566 0-1.13.186-1.507.649-.377.37-.66.926-.66 1.575 0 .648.189 1.204.66 1.574zm5.464-4.353h.847l2.732 4.353V6.653h.754v5.557h-.754l-2.92-4.538v4.538h-.66V6.653z"
          ></path>
          <path
            fill="#FFF"
            d="M64.019 20.48c-2.255 0-4.04 1.683-4.04 4.019 0 2.243 1.785 4.018 4.04 4.018s4.04-1.682 4.04-4.018c0-2.43-1.785-4.018-4.04-4.018zm0 6.355c-1.222 0-2.255-1.028-2.255-2.43 0-1.401 1.033-2.43 2.255-2.43 1.221 0 2.255.935 2.255 2.43 0 1.402-1.034 2.43-2.255 2.43zm-8.738-6.354c-2.255 0-4.04 1.682-4.04 4.018 0 2.243 1.785 4.018 4.04 4.018s4.04-1.682 4.04-4.018c0-2.43-1.785-4.018-4.04-4.018zm0 6.354c-1.222 0-2.255-1.028-2.255-2.43 0-1.401 1.033-2.43 2.255-2.43 1.221 0 2.255.935 2.255 2.43 0 1.402-1.034 2.43-2.255 2.43zm-10.43-5.14v1.683h4.04c-.094.934-.47 1.682-.94 2.149-.563.56-1.503 1.215-3.1 1.215-2.537 0-4.416-1.963-4.416-4.486 0-2.523 1.973-4.486 4.416-4.486 1.316 0 2.35.561 3.1 1.215l1.222-1.215c-1.033-.934-2.349-1.682-4.228-1.682-3.382 0-6.295 2.804-6.295 6.168 0 3.364 2.913 6.168 6.295 6.168 1.88 0 3.195-.56 4.322-1.776 1.128-1.121 1.503-2.71 1.503-3.925 0-.373 0-.747-.093-1.028H44.85zm42.657 1.309c-.375-.935-1.315-2.523-3.382-2.523s-3.758 1.588-3.758 4.018c0 2.243 1.69 4.018 3.946 4.018 1.785 0 2.913-1.121 3.288-1.775l-1.315-.935c-.47.655-1.034 1.122-1.973 1.122-.94 0-1.504-.374-1.973-1.215l5.355-2.243-.188-.467zm-5.45 1.308c0-1.495 1.222-2.336 2.068-2.336.658 0 1.315.374 1.503.84l-3.57 1.496zm-4.415 3.832h1.785V16.462h-1.785v11.682zm-2.819-6.822c-.47-.468-1.222-.935-2.161-.935-1.973 0-3.852 1.776-3.852 4.019 0 2.242 1.785 3.925 3.852 3.925.94 0 1.691-.468 2.067-.935h.094v.56c0 1.496-.846 2.337-2.161 2.337-1.034 0-1.785-.748-1.973-1.402l-1.504.654c.47 1.028 1.598 2.337 3.57 2.337 2.068 0 3.76-1.215 3.76-4.112v-7.103h-1.692v.655zm-2.067 5.513c-1.222 0-2.255-1.028-2.255-2.43 0-1.401 1.033-2.43 2.255-2.43 1.221 0 2.16 1.029 2.16 2.43 0 1.402-.939 2.43-2.16 2.43zm22.926-10.373h-4.228v11.682h1.785V23.75h2.443c1.973 0 3.852-1.401 3.852-3.644 0-2.243-1.879-3.645-3.852-3.645zm.094 5.607H93.24v-4.018h2.537c1.315 0 2.067 1.121 2.067 1.962-.094 1.028-.846 2.056-2.067 2.056zm10.805-1.682c-1.315 0-2.63.56-3.1 1.776l1.597.654c.376-.654.94-.841 1.597-.841.94 0 1.785.56 1.88 1.495v.093c-.283-.186-1.034-.467-1.786-.467-1.691 0-3.383.935-3.383 2.617 0 1.589 1.41 2.617 2.913 2.617 1.222 0 1.785-.561 2.255-1.122h.094v.935h1.691v-4.486c-.187-2.056-1.785-3.27-3.758-3.27zm-.188 6.448c-.564 0-1.41-.28-1.41-1.028 0-.934 1.034-1.215 1.88-1.215.752 0 1.127.187 1.597.374-.188 1.122-1.127 1.87-2.067 1.87zm9.866-6.168l-1.973 5.047h-.094l-2.067-5.047h-1.88l3.101 7.103-1.785 3.925h1.785l4.792-11.028h-1.88zm-15.785 7.477h1.785V16.462h-1.785v11.682z"
          ></path>
          <g transform="translate(9.282 6.69)">
            <path
              fill="url(#linearGradient-1b)"
              d="M.377.394C.094.676 0 1.146 0 1.71v20.764c0 .564.189 1.033.471 1.315l.095.094 11.692-11.65v-.188L.378.395z"
            ></path>
            <path
              fill="url(#linearGradient-2)"
              d="M16.03 16.179l-3.866-3.852v-.282l3.866-3.852.094.094 4.62 2.63c1.32.752 1.32 1.973 0 2.725l-4.714 2.537z"
            ></path>
            <path
              fill="url(#linearGradient-3)"
              d="M16.124 16.085l-3.96-3.946L.377 23.883c.472.47 1.132.47 1.98.094l13.767-7.892"
            ></path>
            <path
              fill="url(#linearGradient-4)"
              d="M16.124 8.193L2.357.394C1.51-.076.85.02.377.488l11.787 11.65 3.96-3.945z"
            ></path>
            <path
              fill="#000"
              d="M16.03 15.99L2.357 23.696c-.754.47-1.414.376-1.886 0l-.094.094.094.094c.472.376 1.132.47 1.886 0l13.673-7.892z"
              opacity="0.2"
            ></path>
            <path
              fill="#000"
              d="M.377 23.695C.094 23.413 0 22.944 0 22.38v.094c0 .564.189 1.033.471 1.315v-.094H.377zM20.744 13.36l-4.714 2.63.094.095 4.62-2.63c.66-.377.943-.846.943-1.316 0 .47-.377.845-.943 1.221z"
              opacity="0.12"
            ></path>
            <path
              fill="#FFF"
              d="M2.357.488l18.387 10.43c.566.375.943.751.943 1.22 0-.469-.283-.939-.943-1.315L2.357.394C1.037-.357 0 .206 0 1.71v.094C0 .394 1.037-.263 2.357.488z"
              opacity="0.25"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default GooglePlay;
